import { ConfigProvider } from 'antd'
import '@/less/reset.less'
// import './App.less'
import styles from './App.module.less'
import { AntdThemeConfig } from './AntdThemeConfig'
import NiceModal from '@ebay/nice-modal-react'
import { ROOT_CONTAINER_ID } from './router/pageConst'
import { RouterProvider } from 'react-router-dom'
import { browserRouter } from './router/routes'
import { useTranslation } from 'react-i18next'
import cls from 'classnames'
import useMessage from 'antd/es/message/useMessage'
import { MessageContext } from './Contexts/Contexts'
import { useEffect } from 'react'

const LANGUAGE_BODY_CLASS_PREFIX = 'adeff-lang-'

function App() {
  const [message, contextHolder] = useMessage()
  const { i18n } = useTranslation()

  useEffect(() => {
    document.body.classList.forEach((className) => {
      if (className.startsWith(LANGUAGE_BODY_CLASS_PREFIX)) {
        document.body.classList.remove(className)
      }
    })
    const languageClassName = `${LANGUAGE_BODY_CLASS_PREFIX}${i18n.language}`
    document.body.classList.add(languageClassName)

    return () => {
      document.body.classList.remove(languageClassName)
    }
  }, [i18n.language])

  return (
    <ConfigProvider theme={AntdThemeConfig}>
      <NiceModal.Provider>
        <div
          id={ROOT_CONTAINER_ID}
          className={cls(styles.adeffPageContainerCls, styles[i18n.language])}
        >
          {contextHolder}
          <MessageContext.Provider value={{ message }}>
            <RouterProvider router={browserRouter} />
          </MessageContext.Provider>
        </div>
      </NiceModal.Provider>
    </ConfigProvider>
  )
}

export default App
